<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransformValidate()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="viewModel?.defKeyField ?? ''"
    [availableSourceFields]="columnLookupAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"
    [compiledConfigHash]="compiledConfigHash" [compiledAt]="compiledAt" [compiledConfig]="compiledConfig" [lastAuditHash]="lastAuditHash" [lastAuditResult]="lastAuditResult" (onAuditCompleted)="onAuditCompleted($event)" [hasRules]="viewModel?.rules?.length > 0"
    [transformType]="viewModel?.transform?.transformType" [currentConfigJson]="viewModel?.toTransformConfig()"></app-transformer-top-header>
    
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex;margin-top: -10px;margin-left: -3px;">
                <div style="margin-right: 10px;">
                    <div style="display: flex; align-items: center;" [formGroup]="formparam">
                    <app-autocomplete-field-with-matform
                        formControlName="defKeyField"
                        [options]="options"
                        [placeholder]="defKeyField.label|| 'Default Key Field'"
                        [(ngModel)]="viewModel.defKeyField"
                        [isrequired]="defKeyField.isrequired"
                    ></app-autocomplete-field-with-matform>
                        <!-- <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{defKeyField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.defKeyField" [required]="defKeyField.isrequired" formControlName="defKeyField">
                                <mat-option *ngIf="defKeyField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('defKeyField').hasError('required')">Default Key Field is required</mat-error>
                        </mat-form-field>
                        <div style="width: 24px;margin-left: 5px;">
                            <img *ngIf="defKeyField.isfillrules" (click)="onSetDefaultRuleParam('sourceColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div> -->
                       <div style="width: 24px;margin-left: 5px;margin-top: 16px;">
                            <img *ngIf="defKeyField.isfillrules" (click)="onSetDefaultRuleParam('sourceColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div> 
                    </div>
                         <!-- ✅ Force error below entire row using full-width div -->
                <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('defKeyField')?.hasError('required') && 
                                    formparam.get('defKeyField')?.touched">
                    {{ defKeyField.label }} is required
                </mat-error>
                </div>
                 
                    <div style="display: flex; align-items: center;" [formGroup]="formparam">
                    <app-autocomplete-field-with-matform
                        formControlName="defLookupField"
                        [options]="optionsLookup"
                        [placeholder]="defLookupField.label|| 'Default Lookup field'"
                        [(ngModel)]="viewModel.defLookupField"
                        [isrequired]="defLookupField.isrequired"
                    ></app-autocomplete-field-with-matform>
                        <!-- <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{defLookupField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.defLookupField" [required]="defLookupField.isrequired" formControlName="defLookupField">
                                <mat-option *ngIf="defLookupField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.lookupColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('defLookupField').hasError('required')">Default Lookup Field is required</mat-error>
                        </mat-form-field> -->
                        <div style="width: 24px;margin-left: 5px;margin-top: 16px;">
                            <img *ngIf="defLookupField.isfillrules" (click)="onSetDefaultRuleParam('targetColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div>
                    </div>
                      <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('defLookupField')?.hasError('required') && 
                                    formparam.get('defLookupField')?.touched">
                    {{ defLookupField.label }} is required
                </mat-error>
                </div>
                </div>
                <div style="margin-right: 10px;">
                    <div style="display: flex; align-items: center;" >
                        <mat-form-field [formGroup]="formparam" style="width: 100%;">
                            <mat-label>{{lookupFarm.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.lookupFarm" [required]="lookupFarm.isrequired" formControlName="lookupFarm" (selectionChange)="onLookupFarmSelected($event)">
                                <mat-option *ngIf="lookupFarm.isselectblank"></mat-option>
                                <mat-option *ngFor="let lookupFarm of LookupFarms" [value]="lookupFarm.nodeid">
                                    <!-- (onSelectionChange)="onLookupFarmSelected(lookupFarm.nodeid,$event)" -->
                                    {{lookupFarm.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('lookupFarm').hasError('required')">Lookup Farm is required</mat-error>
                        </mat-form-field>
                        <div style="width: 24px;margin-left: 5px;" *ngIf="lookupFarm.isfillrules">
                            <img (click)="onSetDefaultRuleParam('sourceColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div>
                    </div>
                
                    <div style="display: flex; align-items: center;" >
                        <mat-form-field [formGroup]="formparam" style="width: 100%;">
                            <mat-label>{{lookupDedup.label}}</mat-label>
                            <!-- <mat-select [(ngModel)]="viewModel.lookupDedup" [required]="lookupDedup.isrequired" formControlName="lookupDedup">
                                <mat-option *ngIf="lookupDedup.isselectblank"></mat-option>
                                <mat-option value="1">Keep First</mat-option>
                                <mat-option value="0">Keep Last</mat-option>
                                <mat-option value="2">No Dedup</mat-option>
                            </mat-select> -->
                            <mat-select [(ngModel)]="viewModel.lookupDedup" [required]="lookupDedup.isrequired" formControlName="lookupDedup">
                                <mat-option *ngIf="lookupDedup.isselectblank"></mat-option>
                                <mat-option *ngFor="let condType of LookupDedups" [value]="condType">
                                    {{LookupDedupUtil.toString(condType)}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('lookupDedup').hasError('required')">Lookup Field De-duplicate is required</mat-error>
                        </mat-form-field>
                        <div style="width: 24px;margin-left: 5px;" *ngIf="lookupDedup.isfillrules">
                            <img (click)="onSetDefaultRuleParam('targetColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div>
                    </div>
                </div>
            <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)">
                <mat-slide-toggle belowSortBy class="lookup-param-toggle" labelPosition="before" color="primary" (change)="onToggleOverwriteRows($event)" [checked]="viewModel.overwriteRows" ><span class="toggleline" [innerHTML]="overwriteRows.label"></span></mat-slide-toggle>
                <div belowIncludeInResults class="lookup-param-toggle" style="display: flex; justify-content: flex-end;">
                    <mat-slide-toggle labelPosition="before" color="primary" (change)="onToggleResetRows($event)" [checked]="viewModel.resetRows" ><span class="toggleline" [innerHTML]="resetRows.label"></span></mat-slide-toggle>
                </div>
            </app-transformer-parameters>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->

         <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                   <span style="margin-right: 30px;">Rules</span>

                    <button 
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule"  class="add-rule-btn" style="height: 24px;border-radius: 2px;">
                        <mat-icon  >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                       style=" line-height: 24px;height: 24px;border-radius: 2px;" color="primary"
                        mat-raised-button title="Show All" class="rule-toggle-btn">
                        <mat-icon>{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                        <!-- {{isRulesMaximized ? 'MINIMIZE' : 'MAXIMIZE'}} -->
                    </button>

                </div>

            </mat-expansion-panel-header>
            <!-- [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div 
                style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell" [ngStyle]="{'display': 'none'}"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">

                            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                               <!-- <mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" class="icon" (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">control_point_duplicate</mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>
                            -->
                            <mat-icon color="primary"
                            style="cursor: grab" 
                            cdkDrag [cdkDragData]="rule"
                            cdkDragRootElement=".drag-component"
                            cdkDragHandle
                            matTooltip="Re-order Rule"  
                            matTooltipPosition="below"
                            #reorderTooltip="matTooltip"
                            (mouseenter)="reorderTooltip.show()"
                            (mouseleave)="reorderTooltip.hide()"
                            >reorder</mat-icon>

                            <mat-icon style="margin-left: 4px; cursor: pointer" 
                            class="icon" 
                            (click)="onDuplicateRule(rule)" 
                            matTooltip="Duplicate Rule" 
                            matTooltipPosition="below"
                            #duplicateTooltip="matTooltip"
                            (mouseenter)="duplicateTooltip.show(); 
                            reorderTooltip.hide()"
                            (mouseleave)="duplicateTooltip.hide()"
                            color="primary">
                            control_point_duplicate
                           </mat-icon>
                           <mat-icon style="margin-left: 2px; cursor: pointer"
                            (click)="onDeleteRule(rule)" 
                            matTooltip="Delete Rule" 
                            matTooltipPosition="below"
                            #deleteTooltip="matTooltip"
                            (mouseenter)="deleteTooltip.show(); duplicateTooltip.hide(); reorderTooltip.hide()"
                            (mouseleave)="deleteTooltip.hide()"
                            class="red-icon">
                            delete_forever
                        </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="ruleName">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Rule Name </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box" [(ngModel)]="rule.name" appAutowidth>
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="targetDataType">
                        <th mat-header-cell *matHeaderCellDef> Target DataType </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.targetDataType">
                                <mat-option></mat-option>
                                <mat-option value="Integer">Integer</mat-option>
                                <mat-option value="Float">Float</mat-option>
                                <mat-option value="Timestamp">Timestamp</mat-option>
                                <mat-option value="Duration">Duration</mat-option>
                                <mat-option value="String">String</mat-option>
                            </mat-select>
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="keyField">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Key Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width" style="border-left: 1px solid #06f312;">
                          <!-- <mat-select [(ngModel)]="rule.keyField">
                                <mat-select-trigger>
                                    <span id="keyField{{rule.index}}" class="green">{{rule.keyField}}</span>
                                </mat-select-trigger>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text"><span style="color: #06f312;">{{col.text}}</span>
                                </mat-option>
                            </mat-select>  -->
                                <app-autocomplete-field 
                                [options]="options"    
                                [placeholder]="defaultKeyColumn" 
                                [(ngModel)]="rule.keyField"
                                id="keyField{{rule.index}}" class="green"
                                ></app-autocomplete-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lookupField">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Lookup Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <!-- <mat-select [(ngModel)]="rule.lookupField">
                                <mat-select-trigger>
                                    <span id="lookupField{{rule.index}}" class="green">{{rule.lookupField}}</span>
                                </mat-select-trigger> 
                                <mat-option *ngFor="let col of viewModel.lookupColumns" [value]="col"><span style="color: #06f312;">{{col}}</span>
                                </mat-option>
                            </mat-select> -->
                            <app-autocomplete-field 
                                [options]="viewModel.lookupColumns"    
                                [placeholder]="defaultLookupColumn" 
                                [(ngModel)]="rule.lookupField"
                                id="lookupField{{rule.index}}" class="green"
                                ></app-autocomplete-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="conditionStart">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #06f312;"> Key Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width" style="border-left: 1px solid #06f312;">
                            <mat-select [(ngModel)]="rule.conditionStart" (selectionChange)="onConditionStartSelected($event,rule)">
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let condType of ConditionStartTypes" [value]="condType">
                                    {{ConditionStartTypeUtil.toString(condType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="keyParams">
                        <th mat-header-cell *matHeaderCellDef> Parameter</th>
                        <td mat-cell *matCellDef="let rule">
                            <input type="text" [disabled]="(rule.conditionStart===ConditionStartType.Contents)" 
                            (keyup)="checkKeyParamsNumber(rule)" 
                            (focusout)="checkKeyParamsOut(rule)"
                            style="border: none; box-sizing: border-box" [(ngModel)]="rule.keyParams" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="conditionEnd">
                        <th mat-header-cell *matHeaderCellDef> Lookup Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.conditionEnd" (selectionChange)="onConditionEndSelected($event,rule)">
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let condType of ConditionEndTypes" [value]="condType">
                                    {{ConditionEndTypeUtil.toString(condType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lookupParams">
                        <th mat-header-cell *matHeaderCellDef> Parameter </th>
                        <td mat-cell *matCellDef="let rule">
                            <input type="text" [disabled]="(rule.conditionEnd===ConditionEndType.Contents)" 
                            (keyup)="checkLookupParamsNumber(rule)" 
                            (focusout)="checkLookupParamsOut(rule)"
                            style="border: none; box-sizing: border-box" [(ngModel)]="rule.lookupParams" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sourceField">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ff9f0c;" [ngStyle]="{'display': 'none'}"> Source Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width" style="border-left: 1px solid #ff9f0c;">
                            <!-- <mat-select [(ngModel)]="rule.sourceField">
                                <mat-select-trigger>
                                    <span id="sourceField{{rule.index}}" class="orange">{{rule.sourceField}}</span>
                                </mat-select-trigger>
                                <mat-option *ngFor="let col of viewModel.lookupColumns" [value]="col"><span style="color: #ff9f0c;">{{col}}</span>
                                </mat-option>
                            </mat-select> -->
                              <app-autocomplete-field 
                                [options]="viewModel.lookupColumns"    
                                [placeholder]="defaultSourceColumn" 
                                [(ngModel)]="rule.sourceField"
                                id="sourceField{{rule.index}}" class="orange"
                                ></app-autocomplete-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="targetField">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Target Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <!-- <mat-select [(ngModel)]="rule.targetField">
                                <mat-select-trigger>
                                    <span id="targetField{{rule.index}}" class="orange">{{rule.targetField}}</span>
                                </mat-select-trigger>
            
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col"><span style="color: #ff9f0c;">{{col}}</span>
                                </mat-option>
                            </mat-select> -->
                            <app-autocomplete-field 
                                [options]="viewModel.targetColumns"    
                                [placeholder]="defaultTargetColumn" 
                                [(ngModel)]="rule.targetField"
                                id="targetField{{rule.index}}" class="orange"
                                ></app-autocomplete-field>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="findReplace">
                        <th mat-header-cell *matHeaderCellDef class="fixed-width-column" style="border-left: 1px solid #ff9f0c;" [ngStyle]="{'display': 'none'}"> Find > Replace </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;" class="fixed-width-column text-overflow" style="border-left: 1px solid #ff9f0c;"
                            (click)="onFindReplaceCellClicked(rule)">
                            <span *ngIf="rule.findReplaceList?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #A6A6A6; font-size:10px; white-space: pre;">Add Find > Replace</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of rule.findReplaceList" [style.color]="containItem.color.color">{{containItem.find }} > {{containItem.replace}} </span>
                        </td>
                    </ng-container>
                    
                    
                    <!-- <ng-container matColumnDef="find">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ffa600;" [ngStyle]="{'display': 'none'}"> Find </th>
                        <td mat-cell *matCellDef="let rule" style="border-left: 1px solid #ffa600;">
                            <input type="text" style="border: none; box-sizing: border-box"
                                [(ngModel)]="rule.find" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="replace">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ffa600;" [ngStyle]="{'display': 'none'}"> Replace </th>
                        <td mat-cell *matCellDef="let rule">
                            <input type="text" style="border: none; box-sizing: border-box"
                            [(ngModel)]="rule.replace" appAutowidth>
                        </td>
                    </ng-container> -->
                    <ng-container matColumnDef="matchAll">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Match All? </th>
                        <td mat-cell *matCellDef="let rule"style="text-align: right;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.matchAll" ></mat-slide-toggle>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ifNoMatch">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Value if no match </th>
                        <td mat-cell *matCellDef="let rule" style="border-left: 1px solid #b8b8b8;text-align: left;min-width: 70px;">
                            <!-- <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.ifNoMatch" appAutowidth> -->
                            <mat-select [(ngModel)]="rule.ifNoMatch" placeholder="None">
                                <mat-select-trigger>
                                    <ng-container *ngIf="rule.ifNoMatch === 'None'; else normalText">
                                        <span style="color: #9f9f9f">{{ rule.ifNoMatch }}</span>
                                    </ng-container>
                                    <ng-template #normalText>
                                       <span id="ifNoMatch{{rule.index}}">{{ rule.ifNoMatch }}</span> 
                                    </ng-template>
                                </mat-select-trigger>
                                <mat-option value="None">None</mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="matchCase">
                        <th mat-header-cell *matHeaderCellDef  [ngStyle]="{'display': 'none'}"> Match Case? </th>
                        <td mat-cell *matCellDef="let rule"  style="text-align: right;width: 40px;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                        </td>
                    </ng-container>

                  <!--  <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}">   <span style="margin-bottom: 4px; text-align: left;">Run?</span> <mat-slide-toggle (change)="onRunChanged($event)"
                                color="primary"></mat-slide-toggle>
                        </th>

                        <td mat-cell *matCellDef="let rule" style="text-align: right;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>-->
                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}">
                            <div style="text-align: centre; margin-bottom:2px;">
                                <span>Run?</span>
                            </div>
                            <mat-slide-toggle (change)="onRunChanged($event)" color="primary"></mat-slide-toggle>
                        </th>
                    
                        <td mat-cell *matCellDef="let rule" style="text-align: right;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>
                    

                    <ng-container matColumnDef="mergeHits">
                        <th mat-header-cell style="border-left: 1px solid #b8b8b8;" *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Merge Hits
                        </th>
                        <td mat-cell style="border-left: 1px solid #b8b8b8;" *matCellDef="let rule">
                            {{rule.mergeHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lookupHits">
                        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Lookup Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.lookupHits | number}} </td>
                    </ng-container>
<!-- Header row first group -->
<ng-container matColumnDef="actionsh">
    <th [attr.rowspan]="2"  mat-header-cell *matHeaderCellDef> </th>
</ng-container>
<ng-container matColumnDef="indexh">
    <th [attr.rowspan]="2"  mat-header-cell *matHeaderCellDef> Rule </th>
</ng-container>
<ng-container matColumnDef="ruleNameh">
    <th [attr.rowspan]="2"  mat-header-cell *matHeaderCellDef> Rule Name </th>
</ng-container>
<ng-container matColumnDef="keyFieldh">
    <th [attr.rowspan]="2"  mat-header-cell *matHeaderCellDef style="border-left: 1px solid #06f312; color: #06f312 !important;"> Key Field </th>
</ng-container>
<ng-container matColumnDef="lookupFieldh">
    <th [attr.rowspan]="2"  mat-header-cell *matHeaderCellDef style="color: #06f312!important;"> Lookup Field </th>
</ng-container>

<ng-container matColumnDef="lookupwhen">
    <th [attr.colspan]="2" mat-header-cell *matHeaderCellDef style="text-align: center;border-left: 1px solid #06f312;border-bottom:0px;"> Lookup When </th>
</ng-container>
<ng-container matColumnDef="matches">
    <th [attr.colspan]="2" mat-header-cell *matHeaderCellDef style="text-align: center;border-bottom:0px;"> Matches </th>
</ng-container>

<ng-container matColumnDef="sourceFieldh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ff9f0c;color:#ff9f0c !important;"> Source Field</th>
    <!-- Source Field<br>(Lookup Farm) -->
</ng-container>
<ng-container matColumnDef="targetFieldh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="color:#ff9f0c !important;"> Target Field</th>
    <!-- Target Field<br>(Data Farm) -->
</ng-container>
<!-- <ng-container matColumnDef="findh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ffa600;"> Find</th>
</ng-container>
<ng-container matColumnDef="replaceh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef> Replace</th>
</ng-container> -->
<ng-container matColumnDef="findReplaceh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ff9f0c;text-align: left;"> Find > Replace</th>
</ng-container>
<ng-container matColumnDef="matchAllh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="text-align: center; width: 40px; white-space: normal;"> 
       Match All? </th>
</ng-container>
<ng-container matColumnDef="ifNoMatchh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="border-left: 1px solid #b8b8b8;text-align: left;"> If no match</th>
</ng-container>
<ng-container matColumnDef="matchCaseh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef   style="text-align: center;width: 40px;"> 
        Match Case?</th>
</ng-container>
<!--<ng-container matColumnDef="isEnabledh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="text-align: right;"> 
        <mat-slide-toggle (change)="onRunChanged($event)" color="primary" labelPosition="before">  <span style="margin-bottom: 4px; text-align: left;">Run?</span></mat-slide-toggle></th>
</ng-container>-->
<ng-container matColumnDef="isEnabledh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="text-align: right; width: 50px;">
        <span style="margin-bottom: 2px;">Run?</span>
        <mat-slide-toggle (change)="onRunChanged($event)" color="primary" labelPosition="before"></mat-slide-toggle>
    </th>
</ng-container>

<ng-container matColumnDef="mergeHitsh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="border-left: 1px solid #b8b8b8;text-align: center;"> Merge Hits</th>
</ng-container>
<ng-container matColumnDef="lookupHitsh">
    <th [attr.rowspan]="2" mat-header-cell *matHeaderCellDef style="text-align: center;"> Lookup Hits</th>
</ng-container>
<tr mat-header-row *matHeaderRowDef="['actionsh','indexh','ruleNameh','keyFieldh','lookupFieldh', 'lookupwhen','matches','sourceFieldh','targetFieldh','findReplaceh','matchAllh','ifNoMatchh','matchCaseh','isEnabledh','mergeHitsh','lookupHitsh']">
</tr>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <!--<tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
                    <tr
  class="drag-component"
  mat-row
  *matRowDef="let row; columns: displayedColumns;"
  (click)="onRowClicked($event, row)"
  [ngClass]="{'highlight-row': selectedRows.includes(row)}">
</tr>

                    <div *cdkDragPlaceholder></div>

                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setColumnLookupResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <div style="position: absolute;left:200px;top: 4px;" *ngIf="globalStat">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 110px; margin-left: 3px;" appearance="outline">
                                <mat-label>Merge Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits"
                                    [value]="viewModel.groupHitCount | number"
                                    matTooltip="Total of unique Input Farm rows whose key matched a value in the Lookup Farm (counted once per row, even when several rules share the same lookup)" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field style="width: 128px; margin-left: 3px;" appearance="outline">
                                <mat-label>Lookup Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits" [value]="viewModel.hitCount | number"
                                    matTooltip="Sum of the Lookup hits — new values added to the Output Farm across all rules" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field style="width: 112px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hit Ratio</mat-label>
                                <input type="text" readonly matInput placeholder="Row Hit Ratio"
                                    [(ngModel)]="viewModel.hitRatioDisplay"
                                    matTooltip="Total Lookup Hits ÷ (Input Farm Rows × active Rule Count)" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field style="width: 118px; margin-left: 3px;" appearance="outline">
                                <mat-label>Merge Misses</mat-label>
                                <input type="text" readonly matInput placeholder="Misses"
                                    [value]="viewModel.missCount | number"
                                    matTooltip="Input Farm rows whose key had no corresponding value in the Lookup Farm" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setColLookupPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Lookup ({{lookupcolumncount}})" >
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #lookupDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transLookupInput" previewTypeName="Lookup"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Lookup)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummarylookup" #menuTriggerLookup="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerLookup,'Lookup')">Summary Fields</button>
                    <span>{{ totalSummaryRowsLookup }}</span>
                    <mat-menu #menusummarylookup="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesLookup" source="Lookup" [emptyColumns]="selectEmptyColumnsLookup" [selectedColumns]="selectFilterValuesLookup" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableLookup [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>